import React, { useState, useEffect } from "react";

import {
    Container, TextField, Button, Typography, Box, Alert,
    InputAdornment, IconButton, Checkbox, FormControlLabel, Divider
} from "@mui/material"; // Tambahkan Divider

import { Visibility, VisibilityOff, Email, Lock } from "@mui/icons-material";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const Login = () => {
    const [email, setEmail] = useState(localStorage.getItem("rememberedEmail") || "");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(!!localStorage.getItem("rememberedEmail"));
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                setError("");
            }, 5000); // 5 detik

            return () => clearTimeout(timer); // bersihkan jika komponen unmount
        }
    }, [error]);

    const handleLogin = async () => {
        setError("");
        setLoading(true); // Mulai loading

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const passwordRegex = /^.{6,}$/;

        if (!email && !password) {
            setError("Email dan password tidak boleh kosong.");
            setLoading(false);
            return;
        }

        if (email && emailRegex.test(email) && !password) {
            setError("Password tidak boleh kosong.");
            setLoading(false);
            return;
        }

        if (email && !emailRegex.test(email)) {
            setError("Format email tidak valid.");
            setLoading(false);
            return;
        }

        if (password && !passwordRegex.test(password)) {
            setError("Format password tidak valid.");
            setLoading(false);
            return;
        }

        try {
            await signInWithEmailAndPassword(auth, email, password);

            if (rememberMe) {
                localStorage.setItem("rememberedEmail", email);
            } else {
                localStorage.removeItem("rememberedEmail");
            }

            navigate("/", { replace: true });
        } catch (err) {
            setError("Login gagal: " + err.message);
        } finally {
            setLoading(false); // selesai
        }
    };

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    mt: 8,
                    p: 4,
                    boxShadow: 3,
                    borderRadius: 2,
                    display: 'flex', // Menggunakan flexbox untuk penataan center
                    flexDirection: 'column', // Mengatur arah flex menjadi kolom
                    alignItems: 'center', // Pusatkan item secara horizontal
                }}
            >
                <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
                    PineTracker
                </Typography>
                <Typography variant="h6" sx={{ mb: 0 }}>
                    Hi, Welcome Back
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Enter your credentials to continue
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ mb: 2, width: '100%' }}> {/* Lebar penuh untuk Alert */}
                        {error}
                    </Alert>
                )}

                <TextField
                    label="Email"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Email />
                            </InputAdornment>
                        ),
                    }}
                />

                <TextField
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    margin="normal"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Lock />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', mt: 1, mb: 2 }}>
                    <FormControlLabel control={<Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />} label="Remember me" />
                    <Button variant="text" sx={{ textTransform: 'none' }}>Forgot Password?</Button> {/* Tombol Forgot Password */}
                </Box>


                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3, width: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={handleLogin}>
                        Login
                    </Button>
                )}

                <Divider sx={{ my: 3, width: '100%' }}> {/* Divider */}
                    <Typography variant="body2" color="text.secondary">OR</Typography>
                </Divider>

                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Don't have an account? <Button variant="text" sx={{ textTransform: 'none', p: 0, minWidth: 0 }}>Register</Button> {/* Link Register */}
                </Typography>

            </Box>
        </Container>
    );
};

export default Login;